/** First-touch signup source. Read once when the page loads, kept in localStorage, sent with signup. */
const KEY = "numi.attr";
export interface Attr { src?: string; medium?: string; campaign?: string; ref?: string }
const clean = (v: string | null, n = 40) => (v || "").toLowerCase().replace(/[^a-z0-9_.\- ]/g, "").trim().slice(0, n);

export function captureAttribution() {
  try {
    const q = new URLSearchParams(location.search);
    const ref = (q.get("ref") || "").toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 12);
    let src = clean(q.get("src") || q.get("utm_source"));
    if (src.startsWith("nudge")) src = ""; // our own emails to existing families: not a signup source
    const medium = clean(q.get("medium") || q.get("utm_medium")), campaign = clean(q.get("campaign") || q.get("utm_campaign"), 60);
    if (!src && !ref) { // fall back to the site they came from
      try { const h = new URL(document.referrer).hostname.replace(/^www\./, ""); if (h && h !== location.hostname) src = clean(h); } catch {}
    }
    let have: Attr = {}; try { have = JSON.parse(localStorage.getItem(KEY) || "{}"); } catch {}
    // an invite is explicit, so it replaces an earlier guess; otherwise the first touch wins
    const next: Attr = ref ? { src: src || undefined, medium, campaign, ref } : have.src || have.ref ? have : { src: src || undefined, medium: medium || undefined, campaign: campaign || undefined };
    if (next.src || next.ref) localStorage.setItem(KEY, JSON.stringify(next));
  } catch {}
}
export function attrPayload(): Attr | undefined { try { return JSON.parse(localStorage.getItem(KEY) || "null") || undefined; } catch { return undefined; } }
export function clearAttr() { try { localStorage.removeItem(KEY); } catch {} }
